

























































































import SelectSessionBtn from "@/views/customize/data-sources/modals/source-details/SelectSessionBtn.vue";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import ScanPermissionStatCard from "./ScanPermissionStatCard.vue";
import { UseModal } from "@/components/root/modal";
import ContentLabelTreeModalVue from "../../common/info-types-modal/ContentLabelTreeModal.vue";
import PermissionCardsLoading from "./PermissionCardsLoading.vue";
import SharepointSites from "./sharepoint-sites-modal/SharepointSites.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";

export default Vue.extend({
  components: {
    SelectSessionBtn,
    ScanPermissionStatCard,
    // PermissionCardsLoading,
    SharepointSites,
    SkeletonLoaderItem,
  },
  setup() {
    const {
      show_permission_cards_loading,
      sessions,
      set_selected_session,
      selected_session,
      permission_counters,
      start_scan,
      view_scan_results,
      selected_labels,
      save_selected_labels_ids,
      selected_permission_card,
      show_websites_for_permission_status_card,
    } = state;

    const show_labels_modal = async () => {
      const res = await UseModal().show(ContentLabelTreeModalVue, {
        labels: selected_labels.value,
      });
      if (res.type == "success") {
        // @ts-ignore
        const selected_labels_ids = res.msg as string[];
        save_selected_labels_ids(selected_labels_ids);
      }
    };

    const start_new_permission_scan = async () => {
      const { state: data_sources } = await import(
        "@/views/customize/data-sources/data/state"
      );
      const res = await data_sources.ext.open_scan_session_modal_for_source(
        "sp_site_permission",
        selected_session.value!.connectionId
      );
      if (res == "refresh") {
        state.init(true);
      }
    };

    onMounted(() => {
      state.init();
    });

    return {
      show_permission_cards_loading,
      sessions,
      selected_session,
      set_selected_session,
      permission_counters,
      start_scan,
      view_scan_results,
      show_websites_for_permission_status_card,
      selected_labels,
      show_labels_modal,
      start_new_permission_scan,
      selected_permission_card,
    };
  },
});
